module.exports = __webpack_public_path__ + "img/conference.ab693245.jpg";